/* eslint-disable import/no-unresolved */
import React from "react";
import ShopCheckOut from "components/pages/user/checkout/shopCheckout";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopCheckOut = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopCheckOut {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopCheckOut);
